<div
  class="modal {{ options && options.classModifier ? 'modal--' + options.classModifier : '' }}"
  #modalContainer
  [@animationModalGrow]="{ value: animateModal, params: { startHeight: startHeight } }"
  @animationModal
  (@animationModal.done)="onAnimationModalDone()"
>
  <ng-template modalContentHost></ng-template>
</div>

<div class="modal-backdrop" [ngClass]="{ 'modal-backdrop--darker': options?.color }" (click)="onBackdropClick()" @fadeInOut></div>
